<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-layout row wrap>
                        <v-toolbar flat color="blue-grey" dark>
                            <v-toolbar-title>Bảng giá thanh toán hộ</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                             <v-layout row wrap>
                                <v-flex lg12 md12 sm12>
                                    <v-icon medium class="mr-2" color="gray darken-3" @click="PayServicePrices_dialog = true">fa-external-link-alt</v-icon>
                                    <v-textarea rows="5" v-model="configuration.PayServicePrices" label="Thanh toán hộ trực tiếp" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12>
                                    <v-icon medium class="mr-2" color="gray darken-3" @click="PayAuthorityPrices_dialog = true">fa-external-link-alt</v-icon>
                                    <v-textarea rows="5" v-model="configuration.PayAuthorityPrices" label="Thanh toán hộ ủy quyền" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
    <oee-excel-editor v-model="configuration.PayServicePrices" title="Thanh toán hộ trực tiếp" editor_width="700px" :columns="PayServicePricesColumns" :dialog="PayServicePrices_dialog" @closePopup="PayServicePrices_dialog = false" @change="configuration.PayServicePrices = $event"></oee-excel-editor>
    <oee-excel-editor v-model="configuration.PayAuthorityPrices" title="Thanh toán hộ ủy quyền" editor_width="800px" :columns="PayAuthorityPricesColumns" :dialog="PayAuthorityPrices_dialog" @closePopup="PayAuthorityPrices_dialog = false" @change="configuration.PayAuthorityPrices = $event"></oee-excel-editor>
</div>
</template>
<script>
import {
    mapState
} from "vuex";
import excel_editor from "@/components/popups/excel_editor"
export default {
    components: {
        'oee-excel-editor': excel_editor
    },
    data() {
        return {
            PayServicePrices_dialog: false,
            PayAuthorityPrices_dialog: false,
            PayServicePricesColumns: [{
                    'name': 'pay_type',
                    'width': '80px',
                    'label': 'Loại hình',
                    'key_field': false,
                    'type': 'string'
                },
                {
                    'name': 'value_from',
                    'width': '160px',
                    'label': 'Tiền thanh toán (Min)',
                    'key_field': false,
                    'type': 'number'
                },
                {
                    'name': 'value_to',
                    'width': '160px',
                    'label': 'Tiền thanh toán (Max)',
                    'key_field': false,
                    'type': 'number'
                },
                {
                    'name': 'rate',
                    'width': '80px',
                    'label': 'Tỷ giá',
                    'key_field': false,
                    'type': 'number'
                },
                {
                    'name': 'ex_fee',
                    'width': '120px',
                    'label': 'Phí thanh toán',
                    'key_field': false,
                    'type': 'number'
                }],
            PayAuthorityPricesColumns: [
                {
                    'name': 'value_from',
                    'width': '160px',
                    'label': 'Tiền thanh toán (Min)',
                    'key_field': false,
                    'type': 'number'
                },
                {
                    'name': 'value_to',
                    'width': '160px',
                    'label': 'Tiền thanh toán (Max)',
                    'key_field': false,
                    'type': 'number'
                },
                {
                    'name': 'rate',
                    'width': '80px',
                    'label': 'Tỷ giá',
                    'key_field': false,
                    'type': 'number'
                },
                {
                    'name': 'ex_fee',
                    'width': '120px',
                    'label': 'Phí thanh toán',
                    'key_field': false,
                    'type': 'number'
                },
                {
                    'name': 'free',
                    'width': '100px',
                    'label': 'Số lệnh free',
                    'key_field': false,
                    'type': 'number'
                },
                {
                    'name': 'unit',
                    'width': '80px',
                    'label': 'Cách tính',
                    'options': ['ex','d'],
                    'key_field': false,
                    'type': 'select'
                }
            ]
        }
    },
    computed: {
        ...mapState({
            loading: state => state.configuration.loading,
            configuration: state => state.configuration.selected
        })
    },
    methods: {
        refreshData() {
            this.$store.dispatch("configuration/getDetail", 1);
        },
        saveData() {
            this.$store.dispatch("configuration/setDetail", {
                data: this.configuration,
                id: this.configuration.ID,
                title: 'bảng giá'
            });
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.configuration.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
